import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('usersAdmin', ['cachedUsers', 'selectedUser']),
}

export const Methods = mapActions('usersAdmin', [
  'fetchUsers',
  'createUser',
  'selectUser',
  'updateUser',
  'changePassword',
])
